module.exports = __webpack_public_path__ + "stylesheets/wave-template-item_762ce2a6e30def2e734521c8664a3e90.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/wave/wave-template-item.less
// module id = aTCW
// module chunks = 118